import throttle from 'lodash.throttle';

class StickyHeader {
  constructor() {
    this.currentScroll = 0;
  }

  selectElements() {
    this.header = document.querySelector('#fixed_header');
    this.body = document.querySelector('body');
    this.tinyBanner = document.querySelector('#tiny_banner_wrapper');

    // Filter elements
    // this.productList = document.querySelector('#product-list-bar');
    // this.productListXs = document.querySelector('#product-list-bar-xs');

    // PDP special case
    this.pdpCart = document.querySelector('.d-overlay');

    // Flagship stores special case
    this.flagshipHeader = document.querySelector('.flagship_container__header');
  }

  addListeners() {
    window.addEventListener('scroll', this.handleScroll);
  }

  setFixed(/* list */) {
    let bodyPadding = 100;
    // let listTop = 100;
    if (this.tinyBanner) {
      bodyPadding += this.tinyBanner.clientHeight;
      // listTop += this.tinyBanner.clientHeight;
    }
    // if (list) bodyPadding += list.clientHeight;
    this.header.style.position = 'fixed';
    this.body.style.paddingTop = `${bodyPadding}px`;
    this.header.style.width = '100vw';
    // if (list) {
    //   list.classList.add('fixed');
    //   // eslint-disable-next-line no-param-reassign
    //   list.style.top = `${listTop}px`;
    // }
    if (this.pdpCart) {
      this.pdpCart.style.top = `${this.header.clientHeight}px`;
      this.pdpCart.style.height = `calc(100vh - ${this.header.clientHeight}px)`;
    }
    if (this.flagshipHeader) {
      this.flagshipHeader.style.top = 'auto';
    }
  }

  setRelative(/* list */) {
    if (this.currentScroll > this.header.clientHeight) {
      this.header.style.position = 'relative';
      this.body.style.paddingTop = '0px';
      this.header.style.width = '100%';
      // if (list) {
      //   list.classList.remove('fixed');
      //   // eslint-disable-next-line no-param-reassign
      //   list.style.top = 'auto';
      // }
      if (this.pdpCart) {
        this.pdpCart.style.top = 0;
        this.pdpCart.style.height = '100vh';
      }
      if (this.flagshipHeader) {
        this.flagshipHeader.style.top = 0;
      }
    }
  }

  handleScroll = throttle(() => {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      this.tinyBanner = document.querySelector('#tiny_banner_wrapper');
      this.pdpCart = document.querySelector('.d-overlay');
      this.flagshipHeader = document.querySelector('.flagship_container__header');
      // let list = this.productList;
      // if (window.innerWidth <= 1024) {
      //   list = this.productListXs;
      // }
      const heightOffset = 0;
      // if (list) {
      //   const rect = list.getBoundingClientRect();
      //   heightOffset = list.clientHeight + rect.top;
      // }
      if (Math.abs(st - this.currentScroll) > 50) {
        if (st > this.currentScroll && st > heightOffset) {
          this.setRelative(/* list */);
        } else if (st > heightOffset) {
            this.setFixed(/* list */);
        } else if (st < heightOffset) {
            this.setRelative(/* list */);
        }
      }
      this.currentScroll = st <= 0 ? 0 : st;
  }, 200);
}

const stickyHeader = new StickyHeader();
stickyHeader.selectElements();
stickyHeader.addListeners();
